import { HttpClient } from "../http";
import type { Subscription, Plan } from "../types";

export class SubscriptionService extends HttpClient {
  constructor() {
    super(process.env.NEXT_PUBLIC_API_URL!);
  }

  async getPlans() {
    return this.get<Plan[]>("/api/plans");
  }

  async getCurrent() {
    return this.get<Subscription | null>("/api/subscription");
  }

  async getHistory() {
    return this.get<Subscription[]>("/api/subscription/history");
  }

  async createOrder(planId: string, billingCycle: "monthly" | "annually", isIndian: boolean) {
    return this.post<{
      orderId: string;
      amount: number;
      amountInCents: number;
      currency: string;
      keyId: string;
      planName: string;
      billingCycle: string;
      creditApplied: number;
      originalAmount: number;
    }>("/api/subscription/order", { planId, billingCycle, isIndian });
  }

  async verifyPayment(payload: {
    orderId: string;
    paymentId: string;
    signature: string;
  }) {
    return this.post<{ success: boolean }>("/api/subscription/verify", payload);
  }

  async cancel() {
    return this.post<{ success: boolean }>("/api/subscription/cancel");
  }
}
